import Practice from "app/models/practice"

export enum Types {
  GET = "PRACTICES_GET",
  GET_SUCCESS = "PRACTICES_GET_SUCCESS",
  GET_FAIL = "PRACTICES_GET_FAIL",
}

export type Action = GetPracticesAction | GetPracticesSuccessAction | GetPracticesFailAction

export type GetPracticesAction = {
  type: Types.GET
}

export type GetPracticesSuccessAction = {
  payload: { data: Practice[] | undefined }
  type: Types.GET_SUCCESS
}

export type GetPracticesFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export function getPractices(): GetPracticesAction {
  return {
    type: Types.GET,
  }
}

export function getPracticesSuccess(data: Practice[] | undefined): GetPracticesSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getPracticesFail(errors: object): GetPracticesFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}
